import React, { useState } from "react";
import QcModalTable from "../QcModalTable/QcModalTable";
import ModaltableHeader from "../ModaltableHeader/ModaltableHeader";
import { Box } from "@mui/system";
import Pagination from "../UtilitiesComponent/Pagination";
import QCModalRejectedTable from "../QcModalTable/QCModalRejectedTable";
import QCModalWebsiteonlyTable from "../QcModalTable/QCModalWebsiteonlyTable";
import styles from "../../styles/pages/editors.module.scss";
import { QCVIDEOMutation } from "../../api/functions/qc.api";
import { useQuery } from "react-query";
import ApiLoader from "../Loaders/ApiLoader";
import QCModalDeniedApprovedRejectedTable from "../QcModalTable/QCModalDeniedApprovedRejectedTable";
import QCModalDeniedApprovedwebsiteTable from "../QcModalTable/QCModalDeniedApprovedwebsiteTable";
import QCModalDeniedRejectedApprovedTable from "../QcModalTable/QCModalDeniedRejectedApprovedTable";
import QCModalDeniedRejectedwebsiteTable from "../QcModalTable/QCModalDeniedRejectedwebsiteTable";
import QCModalDeniedWebsiteApprovedTable from "../QcModalTable/QCModalDeniedWebsiteApprovedTable";
import QCModalDeniedWebsiteRejectedTable from "../QcModalTable/QCModalDeniedWebsiteRejectedTable";
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}
export default function QcDeniedVideo(props) {
  const { children, value, index, ...other } = props;
  console.warn(
    "🚀 ~ file: QcConfirmVideo.jsx:31 ~ QcConfirmVideo ~ selectedId:",
    props?.selectedId?.page
  );
  const [page, setPage] = useState(1);
  const handleDataFromChild = (e) => {
    setPage(e);
    // Do something with the data received from the child component
  };

  const { data: VIDEOList, isLoading } = useQuery(
    ["VIDEOList", props?.selectedId?.selectedId, page, ,],

    async () => {
      return QCVIDEOMutation({
        quality_team_id: props?.selectedId?.selectedId,
        page: page,
        manager_decision: 1,
        quality_team_decision: 2,
      });
    }
  );
  return (
    <>
      <TabPanel value={props?.innerTab} index={0}>
        {/* <ModaltableHeader
          allVideo={true}
          searchType={true}
          pendingBtn={false}
          filterBtn={true}
        /> */}
        <Box className={styles.tableResponsive}>
          {/* {isLoading ? ( */}
          {/* <ApiLoader loading={isLoading} />
          ) : ( */}
          <QCModalDeniedApprovedRejectedTable
            VIDEOList={VIDEOList}
            selectedId={props?.selectedId?.selectedId}
            name={props.name}
          />
          {/* )} */}

          {/* <Box className={styles.innerPagination}>
            <Pagination
              page={page}
              lastpage={VIDEOList?.last_page}
              sendDataToParent={handleDataFromChild}
            />
          </Box> */}
        </Box>
      </TabPanel>
      <TabPanel value={props?.innerTab} index={1}>
        {/* <ModaltableHeader
          allVideo={true}
          searchType={true}
          pendingBtn={false}
          filterBtn={true}
        /> */}
        <Box className={styles.tableResponsive}>
          <QCModalDeniedApprovedwebsiteTable
            selectedId={props?.selectedId?.selectedId}
            name={props.name}
          />

          {/* <Box className={styles.innerPagination}>
            <Pagination
              lastpage={undefined}
              onClick={undefined}
              sendDataToParent={undefined}
            />
          </Box> */}
        </Box>
      </TabPanel>
      <TabPanel value={props?.innerTab} index={2}>
        <Box className={styles.tableResponsive}>
          <QCModalDeniedRejectedApprovedTable
            selectedId={props?.selectedId?.selectedId}
            name={props.name}
          />
          {/* <Box className={styles.innerPagination}>
            <Pagination
              lastpage={undefined}
              onClick={undefined}
              sendDataToParent={undefined}
            />
          </Box> */}
        </Box>
      </TabPanel>
      <TabPanel value={props?.innerTab} index={3}>
        {/* <ModaltableHeader
          allVideo={true}
          searchType={true}
          pendingBtn={false}
          filterBtn={true}
        /> */}
        <Box className={styles.tableResponsive}>
          <QCModalDeniedRejectedwebsiteTable
            selectedId={props?.selectedId?.selectedId}
            name={props.name}
          />
          {/* <Box className={styles.innerPagination}>
            <Pagination
              lastpage={undefined}
              onClick={undefined}
              sendDataToParent={undefined}
            />
          </Box> */}
        </Box>
      </TabPanel>
      <TabPanel value={props?.innerTab} index={4}>
        {/* <ModaltableHeader
          allVideo={true}
          searchType={true}
          pendingBtn={false}
          filterBtn={true}
        /> */}
        <Box className={styles.tableResponsive}>
          <QCModalDeniedWebsiteApprovedTable
            selectedId={props?.selectedId?.selectedId}
            name={props.name}
          />
          {/* <Box className={styles.innerPagination}>
            <Pagination
              lastpage={undefined}
              onClick={undefined}
              sendDataToParent={undefined}
            />
          </Box> */}
        </Box>
      </TabPanel>
      <TabPanel value={props?.innerTab} index={5}>
        {/* <ModaltableHeader
          allVideo={true}
          searchType={true}
          pendingBtn={false}
          filterBtn={true}
        /> */}
        <Box className={styles.tableResponsive}>
          <QCModalDeniedWebsiteRejectedTable
            selectedId={props?.selectedId?.selectedId}
            name={props.name}
          />
          {/* <Box className={styles.innerPagination}>
            <Pagination
              lastpage={undefined}
              onClick={undefined}
              sendDataToParent={undefined}
            />
          </Box> */}
        </Box>
      </TabPanel>
    </>
  );
}
